<template>
  <DialogTemplate class="dialog" position="top-right" margin="small">
    <template #header>
      <div class="header-infos">
        <div class="avatar">
          <img
            v-if="profile.mediaAvatar"
            :src="profile.mediaAvatar.urlCompressed"
          />
          <img v-else class="solid" src="~/assets/images/avatar.png" />
        </div>
        <div class="infos">
          <div class="name">{{ user.fullName }}</div>
          <div v-if="profile.displayEmail" class="email">{{ user.email }}</div>
        </div>
      </div>
    </template>
    <DialogSettingsAction
      v-if="profile.accessType === 'student' || profile.accessType === 'marine'"
      :has-notification="true"
      icon-name="gaming"
      :label="t('gaming.title')"
      to="/gaming#trophees"
    >
      <template #badge>
        <BadgeNotification :count="count" />
      </template>
    </DialogSettingsAction>

    <DialogSettingsAction
      :has-notification="true"
      icon-name="statistics"
      :label="t('settings.stats')"
      to="/mes-statistiques"
    />
    <DialogSettingsAction
      icon-name="account"
      :label="t('settings.account')"
      to="/mon-compte"
    />
    <DialogSettingsAction
      v-if="profile.testMember"
      icon-name="debug"
      :label="t('settings.debug')"
      to="/depatouiller"
    />
    <DialogSettingsAction
      icon-name="settings"
      :label="t('settings.preferences')"
      @click="handleParameters"
    />
    <DialogSettingsAction
      v-if="profile.accessType === 'parent'"
      icon-name="family"
      :label="t('family.button')"
      to="/famille"
    />
    <DialogSettingsAction
      icon-name="faq"
      :label="t('faq.title')"
      to="https://support.nomadeducation.fr/fr/"
      target="_blank"
    />
    <DialogSettingsAction
      icon-name="logout"
      :label="t('logout.button')"
      @click="confirmLogout"
    />
    <template #footer></template>
  </DialogTemplate>
</template>
<script lang="ts" setup>
import DialogSettingsPreferences from '~/components/dialog/settings/preferences/DialogSettingsPreferences.vue';

const user = useUserStore();
const dialog = useDialogStore();
const profile = useProfileStore();
const route = useRoute();
const { t } = useI18n();

const { notifications } = useNotificationsStore();

const count = computed(
  () => notifications.get(NotificationTypes.Trophies).length
);

watch(
  () => route.path,
  () => {
    dialog.close();
  }
);

const handleParameters = () => {
  dialog.open(DialogSettingsPreferences, {
    level: DialogLevel.Settings,
    position: 'top-right',
    fromUserDialog: true,
  });
};

const { confirmLogout } = useAccountLogout();
</script>
<style lang="scss" scoped>
.dialog {
  align-items: flex-start;
  padding: 1rem;
  gap: 2rem;
}
.header-infos {
  display: grid;
  grid-template-columns: 15% auto;
  gap: 2rem;
  @include above('l') {
    width: 40rem;
  }
  .avatar {
    align-self: center;
    overflow: hidden;
    img {
      object-fit: contain;
      &.solid {
        width: 100%;
        height: auto;
        border-radius: 50%;
        background-color: var(--color_neutral_50);
      }
    }
  }
}
.infos {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  align-self: end;
  justify-content: flex-start;
  gap: 0.4rem;
  padding: 0.6rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .name {
    @include font('s', '900');

    width: stretch;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .email {
    @include font('s', '600');

    width: stretch;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
:deep(.content) {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
}
</style>
